import { render, staticRenderFns } from "./ListaDeFacturas.vue?vue&type=template&id=75f8c4bc"
import script from "./ListaDeFacturas.vue?vue&type=script&lang=js"
export * from "./ListaDeFacturas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports